import { trackEvent } from 'core/services/rudderstack_helpers'
import ApplicationController from 'core/controllers/application_controller'

export default class RudderstackController extends ApplicationController {
  static track(eventType, properties) {
    trackEvent(eventType, properties);
  }
}
